import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};
export function Reveal({
  children,
  className,
  delay = 0
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  return <motion.div className={className} initial={reduceMotion ? false : {
    opacity: 0,
    y: 20
  }} whileInView={reduceMotion ? {} : {
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.16
  }} transition={{
    duration: 0.48,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-123">
      {children}
    </motion.div>;
}